<template lang="pug">
    form.start-page-form
        .start-page-form__title Регистрация
        .form__group
            label.form__label Фамилия и Имя
            .form__full
                input(type='text' required v-model="fio" name="fio").form__input
        .form__group
            label.form__label E-mail
            .form__full
                input(type='email' required v-model="email" name="email").form__input
        .form__group
            label.form__label Телефон
            .form__full
                input(type='text' required v-model="tel" name="tel").form__input
        .form__group
            label.form__label Пароль
            .form__full
                input(type='password' required v-model="password").form__input
        .form__group
            label.form__label Подтвердить пароль
            .form__full
                input(type='password' required v-model="password2").form__input
        .form__group
            p-check(name="spam" class="input-round p-svg p-round p-pulse wrap-text" color="primary" required v-model="spam")
                svgicon(name="check" class="svg")
                |Даю согласие на получение уведомлений  и информационных рассылок
        .form__group
            p-check(name="pers" class="input-round p-svg p-round p-pulse wrap-text" color="primary" required v-model="pers")
                svgicon(name="check" class="svg")
                |Даю согласие на обработку
                a(href="#") персональных данных
        button.btn Сохранить

</template>

<script>
export default {
  name: 'Login',
  data: function() {
    return {
      fio: null,
      tel: null,
      email: null,
      password: null,
      password2: null,
      spam: null,
      pers: null
    }
  },
}
</script>

<style lang="scss">
</style>
